// Module
var code = "<input\n  type=\"text\"\n  smart-decimal\n  ng-change=\"MODEL_COL_FIELD.hasChanged = true;MODEL_COL_FIELD.price = MODEL_COL_FIELD.__price\"\n  ng-class=\"'colt' + col.uid\"\n  ui-grid-editor\n  ng-focus=\"MODEL_COL_FIELD.__price = MODEL_COL_FIELD.price\"\n  ng-model=\"MODEL_COL_FIELD.__price\"\n/>\n";
// Exports
module.exports = code;